// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html[lang=ar] .rules-icon,html[lang=fa] .rules-icon,html[lang=he] .rules-icon{transform:rotateY(0deg)!important}html[lang=ar] .invite-root .invite-top-bg .policy-flag,html[lang=fa] .invite-root .invite-top-bg .policy-flag,html[lang=he] .invite-root .invite-top-bg .policy-flag{right:unset;left:0;border-radius:0 .32rem .32rem 0}", ""]);
// Exports
module.exports = exports;
